'use client';

import { useEffect, useId } from 'react';

const useOverflowHidden = (condition = true, targetElementId?: string) => {
  const id = useId();
  useEffect(() => {
    if (!condition) return undefined;
    let targetElement: HTMLElement | null = null;
    if (targetElementId) {
      targetElement = document.getElementById(targetElementId);
      if (targetElement) {
        targetElement.style.overflow = 'hidden';
        const prevIds = (targetElement.dataset.overflowHiddenId || '').split(
          '|',
        );
        targetElement.dataset.overflowHiddenIds = prevIds.includes(id)
          ? prevIds.join('|')
          : prevIds.concat(id).join('|');
      }
    } else {
      document.body.style.overflow = 'hidden';
      const prevIds = (document.body.dataset.overflowHiddenIds || '').split(
        '|',
      );
      document.body.dataset.overflowHiddenIds = prevIds.includes(id)
        ? prevIds.join('|')
        : prevIds.concat(id).join('|');
    }
    return () => {
      if (targetElement) {
        const ids = (targetElement.dataset.overflowHiddenIds || '')
          .split('|')
          .filter(Boolean);
        ids.splice(ids.indexOf(id), 1);
        targetElement.dataset.overflowHiddenIds = ids.join('|');
        if (!ids.length) targetElement.style.overflow = '';
      } else {
        const ids = (document.body.dataset.overflowHiddenIds || '')
          .split('|')
          .filter(Boolean);
        ids.splice(ids.indexOf(id), 1);
        document.body.dataset.overflowHiddenIds = ids.join('|');
        document.body.style.overflow = '';
      }
    };
  }, [targetElementId, condition, id]);
};

export default useOverflowHidden;
